import dayjs from 'dayjs';
import { isEqual, pick } from 'lodash';

import type { Organization } from '@/pages/Organizations';

import type {
  Announcement,
  AnnouncementOrganizationType
} from '../Announcements.types';

const createOrgsArray = (
  orgs: AnnouncementOrganizationType[],
  organizations: Organization[]
) => {
  const orgsArray: string[] = [];
  if (orgs.find((option) => option.label === 'ALL')) {
    organizations.forEach((org: Organization) => {
      orgsArray.push(org.label);
    });
  } else {
    orgs.forEach((option: AnnouncementOrganizationType) => {
      orgsArray.push(option.label);
    });
  }

  return orgsArray;
};

export const isAnnouncementChanged = (
  orig: Announcement,
  changed: Announcement
) => {
  const originalAnnouncement = pick(orig, [
    'org_list',
    'title',
    'body',
    'send_email',
    'scheduled_at'
  ]);
  originalAnnouncement.scheduled_at = dayjs
    .utc(originalAnnouncement.scheduled_at)
    .format();
  const changedAnnouncement = pick(changed, [
    'org_list',
    'title',
    'body',
    'send_email',
    'scheduled_at'
  ]);
  changedAnnouncement.scheduled_at = dayjs(changedAnnouncement.scheduled_at)
    .utc()
    .format();

  return isEqual(originalAnnouncement, changedAnnouncement);
};

/*
    items: Array of currently selected items
    index: Index of the group that was selected
    field: The field that was selected (product_type or industry)
    organizations: Array of all organizations
    groups: Array of all groups (either service groups or industry groups)

    returns an array of selected items with the new items added without any duplicates or groups included
  */
export const getGroupSelectedItems = (
  items: AnnouncementOrganizationType[],
  index: number,
  field: string,
  organizations: Organization[],
  groups: AnnouncementOrganizationType[]
) => {
  // Remove service group from selectedItems
  const itemsNoGroups = items.filter(
    (item: AnnouncementOrganizationType) => !item.group
  );

  switch (field) {
    case 'product_type': {
      // Add orgs that are not already in selectedItems
      const orgsNoDuplicates: Organization[] = organizations.filter(
        (org: Organization) =>
          org.product_type.includes(groups[index].label) &&
          items.indexOf(org as AnnouncementOrganizationType) === -1
      );
      return [
        ...itemsNoGroups,
        ...(orgsNoDuplicates as AnnouncementOrganizationType[])
      ];
    }
    case 'industry': {
      // Add orgs that are not already in selectedItems
      const orgsNoDuplicatesIndustry = organizations.filter(
        (org: Organization) =>
          org.industry === groups[index].name &&
          items.indexOf(org as AnnouncementOrganizationType) === -1
      );
      return [
        ...itemsNoGroups,
        ...(orgsNoDuplicatesIndustry as AnnouncementOrganizationType[])
      ];
    }
    default:
      return items;
  }
};

export default createOrgsArray;
